// extracted by mini-css-extract-plugin
export default {"packages":"packages_PdxRY","packages__topSection":"packages__topSection_nfhwC","packages__bottomSection":"packages__bottomSection_WCFyj"};